import styled from "styled-components";
import { ServiceAirFreightBackground } from "./ServiceAirFreightBackground";
import { ServiceAirFreightExplanation } from "./ServiceAirFreightExplanation";
import { ServiceAirFreightMissionCapability } from "./ServiceAirFreightMissionCapability";
import { ServiceAirFreightRequestQuote } from "./ServiceAirFreightRequestQuote";
import { ServiceRoyalAirFreight } from "./ServiceRoyalAirFreight";
import { ServiceAirFreightAreaOperationNormal } from "./ServiceAirFreightAreaOperation";
import { MainFooter } from "../../Footer/MainFooter";
import { useState } from "react";
import { ModalRequestAirFreight } from "../../Modals";

export function ServiceAirFreightNormal({ pageContent = {} }) {
	const { content = {} } = pageContent || {};
	const [showRequestAirFreight, setShowRequestAirFreight] = useState(false);

	const onRequestAirFreight = () => {
		setShowRequestAirFreight(true);
	};

	return (
		<HomepageContainer>
			<ServiceAirFreightBackground banner={content?.banner} onRequestAirFreight={onRequestAirFreight} />
			<BodyContainer>
				<ServiceAirFreightExplanation what_is_on_demand_air_freight={content?.what_is_on_demand_air_freight} />
			</BodyContainer>
			<BodyContainer>
				<ServiceRoyalAirFreight royal_air_freight={content?.royal_air_freight} />
			</BodyContainer>
			<BodyExperienceContainer>
				<LayoutOverlay>
					<BodyContainer>
						<ServiceAirFreightMissionCapability
							proven_experience_mission_capability={content?.proven_experience_mission_capability}
						/>
					</BodyContainer>
				</LayoutOverlay>
			</BodyExperienceContainer>
			<BodyContainer style={{ maxWidth: "100%", paddingLeft: 0, paddingRight: 0 }}>
				<ServiceAirFreightAreaOperationNormal our_area_of_operation={content?.our_area_of_operation} />
			</BodyContainer>
			<BodyContainer className="ra-air-freight-request-quote">
				<ServiceAirFreightRequestQuote
					request_freight_quote={content?.request_freight_quote}
					onRequestAirFreight={onRequestAirFreight}
				/>
			</BodyContainer>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>

			{/* modals */}
			<ModalRequestAirFreight visible={showRequestAirFreight} onClose={() => setShowRequestAirFreight()} />
		</HomepageContainer>
	);
}

const LayoutOverlay = styled.div`
	width: 100%;
	height: 100%;
	background: rgba(249, 249, 249, 0);
	display: flex;
	justify-content: center;
`;
const BodyExperienceContainer = styled.div`
	width: 100%;
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.png");
	display: flex;
	justify-content: center;
	margin-top: 120px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	@media (max-width: 991px) {
		margin-top: 80px;
	}
	@media (max-width: 767px) {
		margin-top: 60px;
	}
	@media (max-width: 576px) {
		margin-top: 40px;
		background-image: url("/images/private-jet-travel/private-jet-travel-mask-mobile.png");
	}
`;
const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	.ra-air-freight-request-quote {
		padding-bottom: 120px;
	}
	@media (max-width: 767px) {
		.ra-air-freight-request-quote {
			padding-bottom: 80px;
		}
	}
	@media (max-width: 576px) {
		.ra-air-freight-request-quote {
			padding-bottom: 40px;
		}
	}
`;
const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 120px 136px;
	width: 100%;
	scroll-snap-align: start;

	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;
